import React from 'react';
import { LinkSubmitButton } from 'Components/Fields/Buttons';
import { useStore } from 'Hooks/useStore';
import './SignInTVProviderButton.css';

export const SignInTVProviderButton = () => {
  const routes = useStore('appConfig.routes');
  const handleClick = async () => {
    // trackEvent(TRACKING_ENUMS, {});
    //  await dispatch();
  };

  return <LinkSubmitButton className="providerButton" path={routes.mvpd} text="Sign in with TV Provider" />;
};
